<template>
<div>

                          direto
                          {{this.$route.params.Param1}}
                          imprimindo dado banco fixo
                          {{messages}}
</div>

</template>
<script >
export default {
  name: 'teste',
  data: () => ({
    messages: []
  }),
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.messages.push('11111')
      try {
        const res = await this.$firebase.auth().signInWithEmailAndPassword('novo20@btllog.com.br', 'a12345678')
        const ref = this.$firebase.database().ref(`18_05/docs/` + this.$route.params.Param1 + `/threads`)
        ref.on('value', data => {
          this.messages.push('22222')
          data.forEach(grupo => {
            this.messages.push('3333')
            this.messages.push(grupo.key)
          })
        })
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
